import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const problems = ['Llegás al parcial sin saber exactamente qué conceptos van a entrar ni cómo estructurar las respuestas', 'Tus materias teóricas se acumulan porque no encontrás un resumen que realmente sirva para estudiar', 'El 40% de los estudiantes lleva materias a diciembre porque nadie les dio las herramientas correctas desde el principio', 'Siempre los mismos apuntes de siempre porque no tenés material organizado y listo para repasar', 'No podés demostrar tu progreso en las prácticas docentes porque no tenés un sistema de registro profesional visible', 'Planificaciones improvisadas la noche anterior sin un formato claro que te respalde frente al docente', 'Alumnos de distintos niveles juntos en tus prácticas y la clase se convierte en un caos sin herramientas', 'Fin de cuatrimestre sin haber consolidado nada porque la organización fue inconsistente desde el día uno'];
export function Problems() {
  const [showAll, setShowAll] = useState(false);
  // Show 4 on mobile by default, all on desktop
  const visibleOnMobile = showAll ? problems : problems.slice(0, 4);
  return <section className="py-10 md:py-16 bg-white overflow-hidden" data-id="element-299">
      <div className="max-w-4xl mx-auto px-4" data-id="element-300">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-brand-950 mb-6 md:mb-10" data-id="element-301">
          Si cursás el Profesorado de EF en Argentina,{' '}
          <span className="text-accent-600" data-id="element-302">esto te va a sonar familiar:</span>
        </motion.h2>

        {/* Mobile: 4 visible, toggle to expand */}
        <div className="md:hidden grid grid-cols-2 gap-2 mb-6" data-id="element-303">
          {visibleOnMobile.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i % 4 * 0.05
        }} className="flex flex-col items-start gap-1.5 p-3 rounded-xl bg-red-50/50 border border-red-100" data-id="element-304">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 text-red-600 font-black flex items-center justify-center text-[11px]" data-id="element-305">
                0{i + 1}
              </div>
              <p className="text-gray-700 font-medium text-[11px] leading-snug" data-id="element-306">
                {prob}
              </p>
            </motion.div>)}
        </div>

        {/* Mobile expand toggle */}
        <div className="md:hidden flex justify-center mb-8" data-id="element-307">
          <button onClick={() => setShowAll(!showAll)} className="flex items-center gap-1.5 text-xs font-bold text-brand-700 bg-brand-50 border border-brand-200 px-4 py-2 rounded-full hover:bg-brand-100 transition-colors" data-id="element-308">
            {showAll ? 'Ver menos' : `Ver los ${problems.length - 4} restantes`}
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${showAll ? 'rotate-180' : ''}`} data-id="element-309" />
          </button>
        </div>

        {/* Desktop: all 8 always visible */}
        <div className="hidden md:grid grid-cols-2 gap-4 mb-12" data-id="element-310">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-4 p-5 rounded-xl bg-red-50/50 border border-red-100" data-id="element-311">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 text-red-600 font-black flex items-center justify-center text-sm" data-id="element-312">
                0{i + 1}
              </div>
              <p className="text-gray-700 font-medium text-sm leading-relaxed pt-1" data-id="element-313">
                {prob}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-314">
          <h3 className="text-lg md:text-2xl font-black text-brand-900 bg-brand-50 inline-block px-4 py-2.5 md:px-6 md:py-3 rounded-xl border border-brand-100 leading-snug" data-id="element-315">
            ¿Cuántos cuatrimestres más vas a cursar improvisando?
          </h3>
        </motion.div>
      </div>
    </section>;
}